import React from "react";
import { formatAmountBuffer } from "../uiUtils";

// The amount readout over the keypad (POS tvCustomItemPrice). Rendered as a lit display slab rather
// than plain text so it reads as an instrument reading — and so it is unmistakably distinct from the
// cart's GRAND TOTAL, which uses the same slab treatment one size larger. Two numbers that mean very
// different things must not look identical.
export default function AmountDisplay({ buffer }) {
  return (
    <div className="qv-amount">
      <span className="qv-amount-label">Amount</span>
      <span className="qv-amount-value qv-num" aria-live="polite">{formatAmountBuffer(buffer)}</span>
    </div>
  );
}
